import Item from "@/store/Abstract/Item";
export default class EmailConfirmation {
    namespaced = true;
    modules;
    constructor() {
        this.modules = {
            confirmation: new Item(),
            resendConfirmation: new Item(),
        };
    }
}
